import './CTContact.css.proxy.js';
/* src/components/block/CTContact.svelte generated by Svelte v3.35.0 */
import {
	SvelteComponent,
	append,
	attr,
	children,
	claim_component,
	claim_element,
	claim_text,
	create_component,
	destroy_component,
	detach,
	element,
	init,
	insert,
	mount_component,
	safe_not_equal,
	text,
	transition_in,
	transition_out
} from "../../web_modules/svelte/internal.js";

import Wrap from "../slot/Wrap.js";

function create_default_slot(ctx) {
	let div3;
	let h2;
	let t0;
	let a0;
	let t1;
	let div2;
	let div0;
	let h3;
	let t2;
	let p;
	let t3;
	let div1;
	let t4;
	let a1;
	let img;
	let img_src_value;

	return {
		c() {
			div3 = element("div");
			h2 = element("h2");
			t0 = text("お気軽にお問い合わせください");
			a0 = element("a");
			t1 = text("お問い合わせ ▶︎");
			div2 = element("div");
			div0 = element("div");
			h3 = element("h3");
			t2 = text("LINE公式アカウント");
			p = element("p");
			t3 = text("お得な情報をお届けしています。");
			div1 = element("div");
			t4 = text("＞");
			a1 = element("a");
			img = element("img");
			this.h();
		},
		l(nodes) {
			div3 = claim_element(nodes, "DIV", { class: true });
			var div3_nodes = children(div3);
			h2 = claim_element(div3_nodes, "H2", { class: true });
			var h2_nodes = children(h2);
			t0 = claim_text(h2_nodes, "お気軽にお問い合わせください");
			h2_nodes.forEach(detach);
			a0 = claim_element(div3_nodes, "A", { href: true, class: true });
			var a0_nodes = children(a0);
			t1 = claim_text(a0_nodes, "お問い合わせ ▶︎");
			a0_nodes.forEach(detach);
			div2 = claim_element(div3_nodes, "DIV", { class: true });
			var div2_nodes = children(div2);
			div0 = claim_element(div2_nodes, "DIV", { class: true });
			var div0_nodes = children(div0);
			h3 = claim_element(div0_nodes, "H3", { class: true });
			var h3_nodes = children(h3);
			t2 = claim_text(h3_nodes, "LINE公式アカウント");
			h3_nodes.forEach(detach);
			p = claim_element(div0_nodes, "P", { class: true });
			var p_nodes = children(p);
			t3 = claim_text(p_nodes, "お得な情報をお届けしています。");
			p_nodes.forEach(detach);
			div0_nodes.forEach(detach);
			div1 = claim_element(div2_nodes, "DIV", { class: true });
			var div1_nodes = children(div1);
			t4 = claim_text(div1_nodes, "＞");
			div1_nodes.forEach(detach);

			a1 = claim_element(div2_nodes, "A", {
				href: true,
				target: true,
				rel: true,
				class: true
			});

			var a1_nodes = children(a1);
			img = claim_element(a1_nodes, "IMG", { src: true, alt: true, class: true });
			a1_nodes.forEach(detach);
			div2_nodes.forEach(detach);
			div3_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(h2, "class", "svelte-1jzd0oi");
			attr(a0, "href", "/contact");
			attr(a0, "class", "svelte-1jzd0oi");
			attr(h3, "class", "svelte-1jzd0oi");
			attr(p, "class", "svelte-1jzd0oi");
			attr(div0, "class", "heading svelte-1jzd0oi");
			attr(div1, "class", "arrow svelte-1jzd0oi");
			if (img.src !== (img_src_value = "/images/qr.png")) attr(img, "src", img_src_value);
			attr(img, "alt", "LINE公式アカウント");
			attr(img, "class", "svelte-1jzd0oi");
			attr(a1, "href", "https://lin.ee/kkBee2UV");
			attr(a1, "target", "_blank");
			attr(a1, "rel", "noopener noreferrer");
			attr(a1, "class", "svelte-1jzd0oi");
			attr(div2, "class", "line svelte-1jzd0oi");
			attr(div3, "class", "contents svelte-1jzd0oi");
		},
		m(target, anchor) {
			insert(target, div3, anchor);
			append(div3, h2);
			append(h2, t0);
			append(div3, a0);
			append(a0, t1);
			append(div3, div2);
			append(div2, div0);
			append(div0, h3);
			append(h3, t2);
			append(div0, p);
			append(p, t3);
			append(div2, div1);
			append(div1, t4);
			append(div2, a1);
			append(a1, img);
		},
		d(detaching) {
			if (detaching) detach(div3);
		}
	};
}

function create_fragment(ctx) {
	let div;
	let wrap;
	let div_class_value;
	let current;

	wrap = new Wrap({
			props: {
				$$slots: { default: [create_default_slot] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			div = element("div");
			create_component(wrap.$$.fragment);
			this.h();
		},
		l(nodes) {
			div = claim_element(nodes, "DIV", { class: true });
			var div_nodes = children(div);
			claim_component(wrap.$$.fragment, div_nodes);
			div_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(div, "class", div_class_value = "cta cta__" + /*color*/ ctx[0] + " cta__" + /*position*/ ctx[1] + " svelte-1jzd0oi");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			mount_component(wrap, div, null);
			current = true;
		},
		p(ctx, [dirty]) {
			const wrap_changes = {};

			if (dirty & /*$$scope*/ 4) {
				wrap_changes.$$scope = { dirty, ctx };
			}

			wrap.$set(wrap_changes);

			if (!current || dirty & /*color, position*/ 3 && div_class_value !== (div_class_value = "cta cta__" + /*color*/ ctx[0] + " cta__" + /*position*/ ctx[1] + " svelte-1jzd0oi")) {
				attr(div, "class", div_class_value);
			}
		},
		i(local) {
			if (current) return;
			transition_in(wrap.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(wrap.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			destroy_component(wrap);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { color = "blue" } = $$props;
	let { position = "left" } = $$props;

	$$self.$$set = $$props => {
		if ("color" in $$props) $$invalidate(0, color = $$props.color);
		if ("position" in $$props) $$invalidate(1, position = $$props.position);
	};

	return [color, position];
}

class CTContact extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { color: 0, position: 1 });
	}
}

export default CTContact;
//# sourceMappingURL=CTContact.js.map
